import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const item = (
    <span className="font-anton uppercase text-[14vw] leading-none marquee-stroke px-8 select-none">
      Every Rep. Better. —
    </span>
  );
  return (
    <div className="relative py-16 md:py-24 no-x" data-testid="marquee-section">
      <Marquee speed={30} gradient={false} pauseOnHover={false}>
        {item}
        {item}
        {item}
      </Marquee>
    </div>
  );
}
